import React, { useState, useEffect } from 'react';
import { propsToJS } from '__utils/immutable-to-js';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { useSelector } from 'react-redux';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { addAgentCode, getQueryParamsFromString, isFlowTypeCheckout, isFlowTypeProfile, redirectToHome, redirectToOld } from '__utils/common-utils';
import { useMediaQuery } from 'react-responsive';
import { Row, Col } from 'antd';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useForm } from 'react-hook-form';
import { ENDPOINTS } from 'constants/endpoints';
import { getEventName, MinxpanelEventType, Mixpanel } from '__utils/mixpanel';
import moment from 'moment';
import useFlashToggler from 'hooks/use-flash-toggler';
import resolveURLParams from '__utils/url-params-resolver';
import PhysicalMandate from './physicalMandate';
import EMandate from './eMandate';
import { SuccessButton } from 'components/button';
import CustomRadio from 'components/custom-radio';
import { BoldText, FormErrorMessageSpan, InputMintDiv, MandateHr } from 'views/common-styled-components';
import { PenIcon } from 'assets/icons/pen-icon';
import MandateSuccessPopup from './mandate-registration-popup';
import CartSelector from 'views/cart/cart.selector';
import loading from 'images/loading.svg';
import successTick from 'images/success_tick.svg';
import { useDeepCompare } from '../../../hooks/use-deep-memo';
import { useHistory } from 'react-router-dom';
import { getUserDetails } from '__utils/storage';

const MandateContainer = styled.div<any>`
    .newCustradio li p{
        padding-left: 32px !important;
        color: ${COLOR.GREEN}
    }
    .bold{
        font-weight: 500;
    }
    .mandateDetails{
        line-height:1.5;
    }
    .margin-ul{
        margin:16px 0 16px 24px;
        width: ${props => (props.isMobile ? '' : '50%')};
    }
    .margin-ul li{
        margin-bottom: 8px;
    }
    .margin-ul span{
        font-weight: 500;
    }
`;

interface MandateVerifyProps {
    getSipsInCart: any;
    selectedMandateInput: string;
    selectedPaymentTypeInput: string;
    emandateDisabled: boolean;

}
export const mixpanelTrack = (eventName: string, event: MinxpanelEventType) => {
    Mixpanel.track(getEventName(eventName, event, "mandates"));
}
const VerifyMandate: React.FC<MandateVerifyProps> = ({ getSipsInCart, selectedMandateInput, selectedPaymentTypeInput }: MandateVerifyProps) => {
    const flash = useFlashToggler();
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { cartDetails } = propsToJS(useSelector(CartSelector));
    const [selectedMandateType, setSelectedMandateType] = useState<string>(selectedMandateInput);
    const [emandateDisabled, setEmandateDisabled] = useState<boolean>(false);
    const [declChecked, setDeclChecked] = useState<boolean>(false);
    const [inputFieldDisabled, setinputFieldDisabled] = useState<boolean>(true);
    const [mandateScanUploaded, setMandateScanUploaded] = useState<boolean>(false);
    const [mandateLimitAmount, setMandateLimitAmount] = useState<any>();
    const [mandateInputAmt, setMandateInputAmt] = useState<any>();
    const [showLoadingEmandate, setShowLoadingEmandate] = useState<boolean>(false);
    const [sipsInCart, setSipsInCart] = useState<boolean>(false);
    const [showXMandateSuccessPopup, setShowXMandateSuccessPopup] = useState<boolean>(false);
    const { register, handleSubmit, formState : {errors}, trigger } = useForm({ mode: 'onChange' });
    const { mandateId, mandateLimit } = getQueryParamsFromString(window.location.search);
    const [decMandateId, setDecMandateId] = useState<any>();
    const [decMandateLimit, setDecMandateLimit] = useState<any>();

    useEffect(() => {
        mandateId && setDecMandateId(window.atob(mandateId))
    }, [mandateId]);

    useEffect(() => {
        mandateLimit && setDecMandateLimit(window.atob(mandateLimit))
    }, [mandateLimit]);

    useEffect(() => {
        selectedMandateInput && setSelectedMandateType(selectedMandateInput);
    }, [selectedMandateInput]);

    useEffect(() => {
        emandateDisabled && setEmandateDisabled(emandateDisabled);
    }, [emandateDisabled]);

    useEffect(() => {
        if (selectedMandateType) {
            trigger('mandateLimitAmt');
            setMandateScanUploaded(false);
            setDeclChecked(false);
        }
    }, [selectedMandateType]);

    useEffect(() => {
        if (mandateId) {
            setEmandateDisabled(true);
        }
    }, [emandateDisabled]);

    useEffect(() => {
        mandateInputAmt && trigger('mandateLimitAmt');
    }, [mandateInputAmt]);

    useEffect(() => {
        countTotalSipAmount();
    }, [useDeepCompare(cartDetails)]);

    //@purpose: check if items present in cart
    const isCartFull = () => {
        return cartDetails && cartDetails?.noOfItems > 0;
    }

    const showCustomMandateMsg = () => {
        return isFlowTypeProfile() || (isFlowTypeCheckout() && !sipsInCart) || (mandateId && mandateLimit);
    }

    //@purpose: mandate limit is different for x-mandate and e-mandate
    const getMandateMaxLimit = () => {
        return selectedMandateType === 'X' ? 10000000 : 1000000
    }

    //@purpose: disable submit btn if declaration is unchecked for netbanking or mandate isn't uploaded for physical
    const isActivateButtonDisabled = () => {
        if (Object.keys(errors).length === 0 && selectedMandateType === 'X' && mandateScanUploaded) {
            return false;
        } else if (Object.keys(errors).length === 0 && selectedMandateType == 'N' && declChecked) {
            return false;
        }
        return true;
    }

    //@purpose: count total SIP amount in cart
    const countTotalSipAmount = () => {
        setMandateLimitAmount(100000);
        setMandateInputAmt(100000);

        if (isFlowTypeCheckout() && isCartFull()) {
            const cartItems = ('activeCustomizedInvestmentDetailList' in cartDetails ? cartDetails.activeCustomizedInvestmentDetailList : []).concat('activeMintPackInvestmentDetailList' in cartDetails ? cartDetails.activeMintPackInvestmentDetailList : []);
            const sipItems = cartItems.filter((item: any) => {
                return item?.investmentType === "SIP";
            });
            if (sipItems.length > 0) {
                !(mandateId && mandateLimit) && setSipsInCart(true);
                getSipsInCart(true);
                let totalSipAmount = 0;
                sipItems.forEach((sipOrder: any) => {
                    totalSipAmount += sipOrder.totalAmount;
                })
                setMandateLimitAmount(totalSipAmount);
                setMandateInputAmt(Math.max(totalSipAmount, 100000));
            }
        }
    }

    //@purpose: activate mandate
    const activateMandate = (selectedMandateType: string) => {
        post(`${ENDPOINTS.POST_ACTIVATE_MANDATE}?type=${selectedMandateType}&mandateId=${decMandateId ? decMandateId : ''}`, null, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                const result = response.response;
                if (result.meta.message === 'success' && result.data.status === "success") {
                    if (result.data.type === "N") {
                        // go to bank page
                        window.location.href = result.data.responseString;
                    } else {
                        setShowXMandateSuccessPopup(true);
                    }
                }
                else {
                    if (result.meta.message === "failure") flash.error(result.data)
                    else if (result.data.status === "failure") flash.error(result.data.responseString);
                }
            }, (error: AjaxError) => {
                flash.error("Something went wrong. Please try again later")
            });

    }

    //@purpose: register mandate
    const getOrCreateRegisteredMandate = (selectedMandateType: string, data: any) => {
        mixpanelTrack(`mandate${selectedMandateType === 'N' ? 'NetBanking' : 'Physical'}`, 'completed');

        post(`${ENDPOINTS.GET_REGISTERED_MANDATE}?type=${selectedMandateType}&mandateAmount=${mandateInputAmt}&mandateId=${decMandateId ? decMandateId : ''}`, null, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                const result = response.response;
                if (result?.meta.message == "success" && result?.data) {
                    if (selectedMandateType === 'N') {
                        setShowLoadingEmandate(true);
                        var diffTime = moment(result?.data.createdDate).diff(moment(), 'minutes');
                        // Don't wait if mandate was created before 1 minute
                        if (diffTime >= 1) {
                            diffTime = 0;
                        } else {
                            diffTime = 120000 - diffTime;
                        }
                        setTimeout(function () {
                            activateMandate(selectedMandateType);
                        }, diffTime);
                    }
                    else {
                        activateMandate(selectedMandateType);
                    }
                }
                else {
                    flash.error('Failed to get registered mandate. Please try again later.')
                }
            }, (error: AjaxError) => {
                flash.error('Failed to get registered mandate. Please try again later.')
            });
    }

    //@purpose: go to home page if no items presnt in cart else to cart
    const getCTA = () => {
        if (isFlowTypeProfile()) return 'Explore Mutual Funds'
        else {
            if (isCartFull()) return 'Start Investing'
            else return 'Explore Mutual Funds'
        }
    }

    //@purpose: redirection after success
    const sucessRedirection = () => {
        if (isFlowTypeProfile()) redirectToHome();
        else {
            if (isCartFull())
                return redirectToOld(addAgentCode('cart-review'));
            else return redirectToHome();
        }
    }

    const submitMandateHandler = (data: any) => {
        getOrCreateRegisteredMandate(selectedMandateType, data);
    }

    return <MandateContainer isMobile={isMobile}>
        <div>
            <p className='questionFont'>How do you wish to set up mandate?</p>
            <Row className='mb24 mt16'>
                {getUserDetails()?.taxStatus === '01' &&<Col xs={24} md={9}>
                     <CustomRadio
                        name='selectedMandateType'
                        value="N"
                        checked={selectedMandateType === 'N'}
                        disabled={emandateDisabled}
                        onChange={() => setSelectedMandateType('N')}
                        radiobuttonRef={register()}
                        label={<span className='bold' style={{ fontSize: '14px' }}>Using Debit Card/Net Banking</span>}
                        additionalText={
                            <div className='ml20'>
                                <p className='bold font14'>(Recommended)</p>
                                <p className='font14'>Applied online & takes 2-3 days for approval. </p>
                            </div>
                        }
                    />
                </Col>}
                <Col xs={24} md={9}>
                    <CustomRadio
                        value="X"
                        name='selectedMandateType'
                        radiobuttonRef={register()}
                        checked={selectedMandateType === 'X' || getUserDetails()?.taxStatus !== '01'}
                        onChange={() => setSelectedMandateType('X')}
                        label={<span className='bold' style={{ fontSize: '14px' }}>Using physical application form</span>}
                        additionalText={<p className='font14 ml20'>Physical form has to be printed, signed & uploaded. Takes 15 - 20 days for approval.</p>}
                    />
                </Col>
            </Row>

            {isMobile && <MandateHr />}
            <div className='mandateDetails' >
                <p className='questionFont mt0'>Mandate Details</p>
                {showCustomMandateMsg() ? <p className='margin-ul' style={{ margin: '6px 0 20px 0' }}>Once mandate is setup, it ensures that your primary account shall only auto-debit the amount equivalent to your order value. </p>
                    : <ul className='margin-ul'>
                        <li> Mandate should cover the sum total of all orders placed in a day.
                            Kindly set a limit of atleast <span>₹{mandateLimitAmount.toLocaleString('en-IN')}</span> for seamless transactions.</li>
                        <li>We shall only deduct the amount equivalent to your order value.</li>
                    </ul>
                }
            </div>

            <div>
                <p className='mandateFont'>Mandate Limit Amount</p>
                <form id='mandateLimitForm' onSubmit={handleSubmit(submitMandateHandler)}>
                    <Col xs={24} md={10}>
                        <InputMintDiv>
                            <span className="input-symbol-edit input-symbol-rupee">
                                {decMandateLimit ? null : <PenIcon className='edit' onClick={() => { setinputFieldDisabled(false) }}></PenIcon>}
                                <input
                                    name='mandateLimitAmt'
                                    type="number"
                                    step='any'
                                    defaultValue={decMandateLimit ? decMandateLimit : mandateInputAmt}
                                    disabled={inputFieldDisabled}
                                    placeholder="Enter mandate limit amount"
                                    ref={register({
                                        required: "Please enter mandate limit amount",
                                        min: sipsInCart ? mandateLimitAmount : 1,
                                        max: getMandateMaxLimit(),
                                        pattern: {
                                            value: /^[0-9]*$/,
                                            message: "Please enter valid amount."
                                        }
                                    })}
                                    onChange={(event: any) => setMandateInputAmt(event.target.value)}
                                />
                            </span>
                            {(errors.mandateLimitAmt && errors.mandateLimitAmt.type === 'min') ? <FormErrorMessageSpan> Minimum mandate limit is  ₹ {sipsInCart ? mandateLimitAmount.toLocaleString('en-IN') : 1}</FormErrorMessageSpan> : null}
                            {(errors.mandateLimitAmt && errors.mandateLimitAmt.type === 'max') ? (selectedMandateType === 'N' ? <FormErrorMessageSpan>Maximum mandate limit for E-Mandate is  ₹ {getMandateMaxLimit().toLocaleString('en-IN')}. We recommend that you use physical application form for the same.</FormErrorMessageSpan> :
                                <FormErrorMessageSpan>Maximum mandate limit for Physical Mandate is  ₹ {getMandateMaxLimit().toLocaleString('en-IN')}</FormErrorMessageSpan>) : null}
                            {errors.mandateLimitAmt ? <FormErrorMessageSpan>{errors.mandateLimitAmt.message}</FormErrorMessageSpan> : null}

                        </InputMintDiv>
                    </Col>
                </form>

            </div>

            {selectedMandateType === 'N' && <EMandate selectedPaymentTypeInput={selectedPaymentTypeInput} onDeclCheck={setDeclChecked} />}

            {selectedMandateType === 'X' && <PhysicalMandate mandateLimitAmount={mandateInputAmt} onMandateScanUpload={setMandateScanUploaded} />}<br />

            <div className={isMobile ? 'sticky-footer' : ''} >
                <SuccessButton width={isMobile ? '' : '160px'} type="submit" form="mandateLimitForm" disabled={isActivateButtonDisabled()}> Setup Mandate</SuccessButton>
            </div>

        </div>

        {showLoadingEmandate &&
            <MandateSuccessPopup
                onClose={() => {
                    setShowLoadingEmandate(false);

                }} >
                <div className="mandateLoader">
                    <img src={loading} alt="loader" className="loaderIcon" />
                    <h4>Just a moment...</h4>
                    <p>Redirecting to your bank&apos;s portal</p>
                </div>
            </MandateSuccessPopup>
        }

        {
            showXMandateSuccessPopup && <MandateSuccessPopup
                mandateType='X'
                onClose={() => {
                    setShowXMandateSuccessPopup(false);
                    history.push('/profile/mandates')
                }} >
                <div>
                    <img src={successTick} />
                    <BoldText>Success !</BoldText>
                    <p className='successText'>
                        You have successfully registered for mandate. You can expect approval within next 20 days.</p>
                    <br />
                    <div className={isMobile ? "sticky-footer" : ""}>
                        <SuccessButton onClick={() => sucessRedirection()}>{getCTA()}</SuccessButton>
                    </div>
                </div>

            </MandateSuccessPopup>
        }
    </MandateContainer>;
}

export default VerifyMandate;